import { makeStyles } from '@material-ui/core/styles'

export default makeStyles({
  playerContainer: {
    padding: 10,
    width: '100%',
    display: 'flex'
  },
  player: {
    border: 0
  }
})
